export class ScreenAuth {
    screenId: number;
    screenName: string;
    moduleName: string;
    subModuleName: string;
    moduleId: number;
    subModuleId: number;
    fullAccessFlag: boolean;
    addFlag: boolean;
    editFlag: boolean;
    viewFlag: boolean;
    deleteFlag: boolean;
    approveFlag: boolean;
    exportFlag?: boolean;
}
